import * as yup from "yup";

const filterValidation = yup.object().shape({    
    search_tabs: yup.object().shape({
      value: yup.string().min(3, "Min 3 characters").max(60, "Max 60 characters"),
      types: yup.array().when("value", {
        is: (value) => value,
        then: yup.array().of(yup.string()).required("Required"),
      }),
    }),    
});
  
export default filterValidation;